export default __webpack_public_path__ + "static/media/JavaBlog.7d22247e.jpg";